<template>
  <PageWrap
    wide
    :heading="$t('admin.nav.links.accounts')"
  >
    <template #actions>
      <BaseButton
        :routerLink="{ name: 'admin-account-new' }"
        v-test="'user-accounts-btn-add'"
      >
        {{ $t('admin.user_accounts.add_account_button_text') }}
      </BaseButton>
    </template>
    <UserAccounts :mb="2" />
    <UserLogs />
  </PageWrap>
</template>

<script
  lang="ts"
  setup
>
import PageWrap from '../PageWrap.vue';
import UserAccounts from './UserAccounts.vue';
import UserLogs from './UserLogs.vue';
import { provideUserAccounts } from './useUserAccounts';

provideUserAccounts();
</script>
